import Game from "../../src/shell/Game";
import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { actor } from "../characters/Actor";
import { actress } from "../characters/Actress";
import { ann } from "../characters/Ann";
import { director } from "../characters/Director";
import { mc } from "../characters/MC";
import { doTransition } from "../helpers/helpers";
import { images } from "./images";
import { V6AnnAuditionNo1After } from "./V6";

export const V6AnnBeforeAudition_Question = async (): Promise<any> => {
    await director.set((properties) => {
        director.name = "Phil Malot";
    });
    ImageClass.setImage(images.v6.AnnArrivedNew_2);
    await ann.setQuestion(new Question({ text: `Do you like it?`, options: { think: false }, key: `v6ToldAnnSheLooksLikeASlut` })
        .option({ title: `You look like a slut`, key: true })
        .option({ title: `I do`, key: false }));


    if (Question.globalAnswers.v6ToldAnnSheLooksLikeASlut) {
        await ann.set((properties) => {
            properties.corruption++;
        });

        return jump(V6AnnBeforeAudition_Question_Slut, "V6AnnBeforeAudition_Question_Slut");
    } else {

        return jump(V6AnnBeforeAudition_Question_IDo, "V6AnnBeforeAudition_Question_IDo");
    }
};


export const V6AnnBeforeAudition_Question_Slut = async (): Promise<any> => {
    ImageClass.setImage(images.v6.AnnArrivedNew_2);
    mc.talk(`You look like a slut.`);
    ImageClass.setImage(images.v6.AnnArrivedNew_18);
    ann.talk(`Oh...`);
    mc.talk(`That's not a bad thing.`);
    ann.talk(`It's not? It sounds bad...`);
    mc.talk(`Guys like slutty girls, that's why they are so popular!`);
    ImageClass.setImage(images.v6.AnnArrivedNew_3);
    ann.talk(`Oh... Hehe, ok I guess.`);
    ann.talk(`So you do like it!`);
    mc.talk(`Of course I do.`);
    return jump(V6AnnAuditionNo1, "V6AnnAuditionNo1");
};

export const V6AnnBeforeAudition_Question_IDo = async (): Promise<any> => {
    ImageClass.setImage(images.v6.AnnArrivedNew_2);
    await mc.set((properties) => {
        properties.annRelationship++;
    });
    mc.talk(`I do.`);
    mc.talk(`You look extremely hot.`);
    ann.talk(`Hehe! Thanks!`);
    ImageClass.setImage(images.v6.AnnArrivedNew_3);

    return jump(V6AnnAuditionNo1, "V6AnnAuditionNo1");
};

export const V6AnnAuditionNo1 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.AnnArrivedNew_3);
    // NEW
    ann.talk(`Are you ready to head out?`);
    mc.talk(`Ready, but you still haven't told me where we are going.`);
    ann.talk(`It's a surprise. I'll tell you once we get close.`);

    mc.talk(`Alright, let's go.`);
    ImageClass.setImage(images.v6.AnnAudition_0, { transition: true, duration: 0.6 });
    ann.talk(`Since we are almost there I'll tell you.`);
    ann.talk(`Ok... So... Do you remember that I said that I wanna take a chance of becoming an actress?`);
    mc.talk(`I do, but to be honest, I didn't think you were serious about that.\nI thought it was just because you really wanted to see that movie.`);
    ann.talk(`I was serious and you're going to see just how serious!`);
    mc.talk(`...`);
    ann.talk(`We are going to watch an open audition!`);
    ann.talk(`The director, ${director.name}, is looking for a new starlet for his new film!`);

    ann.talk(`He wrote on his twit that he isn't looking for an experienced actress, he just wants to find the next big star.`);
    mc.talk(`Is that why you dressed like that?`);
    ann.talk(`Mmm... I googled for tips on how to stand out during the audition and one of them stated that you should wear something... Provocative.`);
    mc.talk(`Now I see.`);
    mc.talk(`Are you going to audition right now?`);
    ann.talk(`No, hehe. He said that he'll be in town for two days, so I'm just going to watch for now and I'll decide if I wanna give it a shot tomorrow.`);
    mc.talk(`Sounds brave.`);
    ann.talk(`Hehe, thanks!`);



    return jump(V6AnnAuditionNo1_2, "V6AnnAuditionNo1_2");
};

export const V6AnnAuditionNo1_2 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.AnnAudition_1, { transition: true });
    actress.talk(`So please... Please... I didn't... Mean it?`);
    actor.talk(`Don't lie to me, I saw your pics on Insta! Do you think that I'm stupid?`);
    ImageClass.setImage(images.v6.AnnAudition_2);
    ann.talk(`Oh wow, they already started... I hope we didn't miss much.`);
    mc.talk(`There aren't many people here.`);
    ann.talk(`Better for me!`);
    ann.talk(`Let's sit.`);
    ImageClass.setImage(images.v6.AnnAudition_3);
    actress.talk(`No no no... Please don't leave me.`);
    actor.talk(`Convince me.`);
    actress.talk(`I... I... I will learn how to cook better...`);
    actor.talk(`Food was always my sweet spot, but it's ain't gonna cut it.`);
    actress.talk(`I... I... I'll stop bothering you when you watch football on TV...`);

    ImageClass.setImage(images.v6.AnnAudition_4);
    director.talk(`STOP!`);
    ImageClass.setImage(images.v6.AnnAudition_4_2);
    director.talk(`What the fuck do you think you are doing?`);
    actress.talk(`... Me?`);
    director.talk(`Who do you think? Of course YOU!`);

    director.talk(`I brought you a talented actor so you wouldn't have to talk to the wall and that's the best you come up with?`);
    director.talk(`And what the fuck is that paper you are holding?`);
    actress.talk(`It's just some ideas I wrote beforehand...`);
    director.talk(`Obviously it's not helping because your acting is dog shit.`);
    director.talk(`But I'm in a good mood, I'll let you continue.`);
    mc.think(`I wonder what he's like when he is in a bad mood.`);
    director.talk(`Go.`);

    return jump(V6AnnAuditionNo1_3, "V6AnnAuditionNo1_3");
};

export const V6AnnAuditionNo1_3 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.AnnAudition_3);
    actress.talk(`I'm... Sorry honey! I didn't mean it!`);
    ImageClass.setImage(images.v6.AnnAudition_4);
    director.talk(`STOP!!!`);
    ImageClass.setImage(images.v6.AnnAudition_4_2);
    director.talk(`Where is the passion?`);
    actress.talk(`Passion?`);
    ImageClass.setImage(images.v6.AnnAudition_5);
    director.talk(`Do you want the part?`);
    actress.talk(`More than anything...`);
    director.talk(`So I want more passion in your acting.`);
    ImageClass.setImage(images.v6.AnnAudition_6);
    ann.talk(`That was harsh...`);
    ann.talk(`I knew that he is tough, but I didn't realize how much.`);
    mc.talk(`He is, but he is not wrong... That girl's acting sucks...`);
    ann.talk(`True, but it's an audition for inexperienced actresses so he must have expected it.`);

    ann.talk(`Let's just keep watching.`);
    ImageClass.setImage(images.v6.AnnAudition_5);
    director.talk(`This scene is about a couple that are about to break up. And the girl, YOU, needs to convince him not to walk out the door.`);
    director.talk(`Get into the character's shoes, this man is the love of your life, you can't let him go.`);


    ImageClass.setImage(images.v6.AnnAudition_5);
    actress.talk(`Do you want me to do something different?`);
    director.talk(`I want you to do everything different!`);
    ImageClass.setImage(images.v6.AnnAudition_7);
    director.talk(`You are a couple, so start by standing closer to each other.`);
    director.talk(`Now, make me believe that you really want him to stay with you.`);
    director.talk(`Make me believe you love him.`);
    director.talk(`Make me believe he is the only man you care about.`);
    director.talk(`Understood?`);
    actress.talk(`Yes Sir.`);
    ImageClass.setImage(images.v6.AnnAudition_9);
    director.talk(`Go.`);
    ImageClass.setImage(images.v6.AnnAudition_12);
    actress.talk(`I... I love you so much! Please don't leave me.`);
    actor.talk(`I used to love you too... But my love has faded away.`);
    actor.talk(`You don't care about me, all you care about are your girlfriends. I can barely get any attention from you.`);
    actress.talk(`But... Honey... Please I'll change...`);
    actress.talk(`Can you forgive me?`);
    actress.talk(`... Please?`);
    return jump(V6AnnAuditionNo1_4, "V6AnnAuditionNo1_4");
};

export const V6AnnAuditionNo1_4 = async (): Promise<any> => {
    ImageClass.setImage(images.v6.AnnAudition_12_2);
    director.talk(`STOP!`);
    director.talk(`I'm sick of you.`);
    ImageClass.setImage(images.v6.AnnAudition_8);
    director.talk(`Get the fuck off my stage.`);
    ImageClass.setImage(images.v6.AnnAudition_10);
    director.talk(`Who's next?`);
    director.talk(`Anyone?`);
    director.talk(`Why did you come here if none of you are going to step up?`);
    director.talk(`I thought you want to become famous.`);
    ImageClass.setImage(images.v6.AnnAudition_11);
    director.talk(`Naked girl, what about you?`);
    ann.talk(`...`);
    ImageClass.setImage(images.v6.AnnAudition_13);
    director.talk(`Hello! I'm talking to you.`);
    ann.talk(`Me?`);
    director.talk(`Do you see any other naked girls around?`);
    ann.talk(`I am not naked...`);
    director.talk(`Do you want to audition or not?`);
    ann.talk(`I just came here to watch.`);
    director.talk(`What do you think it is? A show?`);
    ann.talk(`I came to listen and take notes...`);
    director.talk(`I can respect that. But I hope you know tomorrow is my last day in this city.`);
    director.talk(`So show up or don't let me see your face again in my try-outs.`);
    ann.talk(`Ok...`);
    ImageClass.setImage(images.v6.AnnAudition_10);
    director.talk(`Since no one else wants to try her luck, I'll see you girls tomorrow.`);
    director.talk(`Don't forget. It's your last chance, you better be here with your A game.`);
    return jump(V6AnnAuditionNo1Outside, "V6AnnAuditionNo1Outside");
};

export const V6AnnAuditionNo1Outside = async (): Promise<any> => {
    ImageClass.setImage(images.v6.AnnSecondAudition_9, { transition: true });
    ann.talk(`Wow... That was something else.`);
    mc.talk(`Does that mean that you are giving up on the audition?`);
    ann.talk(`No... Let's just get out of here before he finds another reason to yell at me.`);
    ann.talk(`Can we go to your place?`);
    mc.talk(`Sure, why not, let's go.`);
    return jump(V6AnnAuditionNo1MCHome, "V6AnnAuditionNo1MCHome");
};

export const V6AnnAuditionNo1MCHome = async (): Promise<any> => {
    doTransition(images.v6.AnnArrivedNew_20);
    mc.talk(`Do you want something to drink?`);
    ImageClass.setImage(images.v6.AnnArrivedNew_19);
    ann.talk(`No, thanks.`);
    ImageClass.setImage(images.v6.AnnArrivedNew_20);
    mc.talk(`Yeah, you started saying something about how you aren't going to back down on the audition.`);

    ImageClass.setImage(images.v6.AnnArrivedNew_17);
    ann.talk(`Yes, exactly, I still want to try...`);
    mc.talk(`At first I thought it could be nice, but after seeing that shit show back there I don't know... Do you really wanna do that?`);
    ann.talk(`What do I have to lose? Worst case scenario he would tell me to piss off... Hehe.`);

    ImageClass.setImage(images.v6.AnnArrivedNew_19);
    ann.talk(`And that brings me to my next subject...`);
    ImageClass.setImage(images.v6.AnnArrivedNew_17);
    ann.talk(`I could really use your help.`);
    ImageClass.setImage(images.v6.AnnArrivedNew_20);
    mc.talk(`My help? With what?`);
    ImageClass.setImage(images.v6.AnnArrivedNew_19);
    ann.talk(`Well, I'll improvised some dialogues, and you can tell me if it sounds good or not.`);
    ImageClass.setImage(images.v6.AnnArrivedNew_20);
    mc.talk(`I don't mind, but I know nothing about acting.`);
    ImageClass.setImage(images.v6.AnnArrivedNew_17);
    ann.talk(`You know more than me, that's for sure!\nBesides, I trust your judgment.`);

    ann.talk(`Anyway! It's not gonna be today! I made plans with Vanessa, I believe she invited you as well, right?`);

    ImageClass.setImage(images.v6.AnnArrivedNew_20);
    mc.talk(`She did.`);
    ImageClass.setImage(images.v6.AnnArrivedNew_19);
    ann.talk(`Great! So I'll see you in a few hours!`);

    ImageClass.setImage(images.v6.AnnArrivedNew_20);
    mc.talk(`You realize that the last auditions are tomorrow.`);

    ImageClass.setImage(images.v6.AnnArrivedNew_19);
    ann.talk(`I know... I'll have to take my chances, if it's meant to be I'll get the part...`);

    ImageClass.setImage(images.v6.AnnArrivedNew_20);
    mc.talk(`Sounds like a long shot.`);
    ImageClass.setImage(images.v6.AnnArrivedNew_17);
    ann.talk(`With your help my chances will be higher!`);
    ImageClass.setImage(images.v6.AnnArrivedNew_19);
    ann.talk(`Ok, I need to go, I'll see you tonight at Vanessa's place.`);
    ImageClass.setImage(images.v6.AnnArrivedNew_20);
    if (Game.seenScenarios.includes(`V5AnnSexEveningVanessaJoined4`)) {
        mc.talk(`Wait, before you go there is something I wanted to ask.`);
        ImageClass.setImage(images.v6.AnnArrivedNew_17);
        ann.talk(`Yes?`);
        ImageClass.setImage(images.v6.AnnArrivedNew_20);
        mc.talk(`First I had a great time yesterday... But when Vanessa kinda kicked me out and I tried talking to you, you didn't respond.`);
        mc.talk(`So I was wondering what was that about.`);
        ImageClass.setImage(images.v6.AnnArrivedNew_17);
        ann.talk(`Oh! Hehe, nothing really... I guess I was out of focus from that pill Vanessa gave me.`);
        mc.talk(`I hope you are saying that in a good way.`);
        ann.talk(`Of course! I really really liked it!`);
        mc.talk(`Ok.`);
        ann.talk(`That's all?`);
        mc.talk(`Yeah.`);
        ann.talk(`Ok, so I'll cya!`);

    } else {

    }

    ImageClass.setImage(images.v6.AnnArrivedNew_20);
    mc.talk(`Cya tonight.`);
    return jump(V6AnnAuditionNo1After, "V6AnnAuditionNo1After");
};